import Shows from '../components/Shows'

function Archive() {

  return (
  	<div className="page">
			<br />
	    <header className="home-header">
		    <div>
		      Archive
		    </div>
	    </header>

	    <Shows 
	    	filterShows={s => s.ts < Date.now()}
			sortShows={-1}
	    	hiddenProperties={{
	    		locationName: true,
	    		ticketLink: true,
	    		address: true,
	    		price: true,
	    	}}
	    />
    </div>
  )
}

export default Archive
